// extracted by mini-css-extract-plugin
export default {"container":"AddCustomFields__container___pzKge","removeBorder":"AddCustomFields__removeBorder___G37iF","hide":"AddCustomFields__hide___PhGNo"};